import { default as ModuleContext } from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { ModalWrapper } from 'components/ModalWrapper';
import SearchBarDialect from 'components/search/SearchBarDialect';
import { useForceRender } from 'hooks/useForceRender';
import ItemModel, { IItem } from 'models/ItemModel';
import React, { useContext, useMemo } from 'react';
import { IGridData } from 'types/models';

type IProps = {
  onClose: () => void;
  onChooseItem: (data: IItem) => void;
};

const ItemSearchModal: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();

  const moduleModel = useContext(ModuleContext);

  const itemsModel = useMemo(() => new ItemModel({ render: forceRender, courseId: moduleModel.courseId }), [
    forceRender,
    moduleModel.courseId,
  ]);

  const handleSearch = (text: string, dialect: string) => {
    itemsModel.getGridSearch(text, dialect);
  };

  const handleRowClick = (data: IGridData) => {
    props.onChooseItem(data as IItem);
  };

  return (
    <ModalWrapper title="Search Item" width={468} height={555} onClose={props.onClose}>
      <ModuleContext.Provider value={itemsModel}>
        <SearchBarDialect handleSearch={handleSearch} />
        <Grid handleRowClick={handleRowClick} />
      </ModuleContext.Provider>
    </ModalWrapper>
  );
};

export default ItemSearchModal;
